import React from "react";
import { Box, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import clsx from "clsx";
import Attendance from "../../../../Assets/Card/Clock.svg";
import Students from "../../../../Assets/Card/studentsCard.svg";
import GradeIcon from "../../../../Assets/Card/Grades.svg";
import AssignmentIcon from "../../../../Assets/Card/Assignments.svg";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  statsTextItem: {
    flexGrow: 1,
  },
  statsText: {
    fontSize: "48px",
    color: theme.palette.KenColors.primary,
    [theme.breakpoints.only("xs")]: {
      fontSize: "24px",
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: "36px",
    },
  },
  statsSubText: {
    fontSize: "16px",
    color: theme.palette.KenColors.primary,
    [theme.breakpoints.only("xs")]: {
      fontSize: "12px",
    },
  },
  statsImageItem: {
    margin: "auto",
    // paddingTop: '24px !important',
    padding: 0,
  },
  statsImage: {
    height: 60,
    width: 60,
    maxWidth: 70,
    maxHeight: 70,
    [theme.breakpoints.only("xs")]: {
      height: "42px",
      width: 42,
    },
  },
}));

export default function EtlHome() {
  const classes = useStyles();
  const { t } = useTranslation();

  const DataArray = [
    {
      text: "234",
      subLine: t("headings:Students"),
      image: `${Students}`,
      // backImage: `${kpiBackgroundImg}`,
    },
    {
      text: "75%",
      subLine: t("headings:Attendance"),
      image: `${Attendance}`,
      // backImage: `${kpiBackgroundImg}`,
    },
    {
      text: "23",
      subLine: t("headings:Task_Submission"),
      image: `${AssignmentIcon}`,
      // backImage: `${kpiBackgroundImg}`,
    },
    {
      text: "4.2",
      subLine: t("headings:Your_Rating"),
      image: `${GradeIcon}`,
      // backImage: `${kpiBackgroundImg}`,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      {DataArray.map((el, key) => {
        return (
          <Grid style={{ width: "20%" }}>
            <Paper className={classes.paperStats} style={{ padding: 10 }}>
              <Grid container spacing={1}>
                <Grid item md={8} sm={12} xs={8}>
                  <Grid className={classes.statsTextItem}>
                    <Typography
                      className={clsx(classes.statsText, classes[el.className])}
                    >
                      {el.text}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      className={classes.statsSubText}
                      color='textSecondary'
                    >
                      {el.subLine}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  item
                  md={4}
                  sm={12}
                  xs={4}
                  item
                  className={classes.statsImageItem}
                >
                  <Box>
                    <img src={el.image} className={classes.statsImage} />
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        );
      })}
    </Box>
  );
}
